import { commonFeedConstants as fc } from 'srcReact/components/common2/FeedsTabContent/constants'

const initialState = {
  users: [], //all users involved in all feed posts,
  newsFeedId: 0,
  newsFeedType: '',
  organizationId: 0,
  workplaceIds: '',
  entity: 0, // either mixr id or group id
  groupId: 0, // required for getTagUsers api call for mixr and group feed,
  pendingMessageCount: {
    newsFeedId: -1,
    count: 0
  },
  feeds: {
    list: [],
    stats: null,
    loading: false,
    error: '',
    success: false,
    loggedUserData: null
  },
  createEditFeed: {
    loading: false,
    success: false,
    originMessageId: 0,
    action: '',
    error: ''
  },

  deleteFeed: {
    loading: false,
    success: false,
    error: '',
    originMessageId: 0
  },
  draftMessages: {
    message: ''
  },
  newsFeedList: {
    selected: null,
    mixrs: [],
    groups: []
  },
  moderation_info: null,
  authUser: null,
  reaction: {
    loading: false,
    success: false,
    error: '',
    data: null
  },
  updateMedia: {
    action: '', //edit/delete
    loading: false,
    success: false,
    error: ''
  },
  translate: {
    loading: false,
    error: ''
  },
  scrollToPost: {
    post_id: 0,
    newsfeed_id: 0,
    content_offset: 0
  },
  feedTags: {
    loading: false,
    tags: [],
    error: ''
  },
  sharedTags: {
    loading: true,
    files: [],
    error: ''
  },
  membersWithActivities: []
}

export function commonNewsfeed(state = initialState, action) {
  const { response } = action

  switch (action.type) {
    case fc.SELECTED_NEWSFEED:
      return {
        ...state,
        newsFeedId: action.newsFeed.id,
        newsFeedList: {
          ...state.newsFeedList,
          selected: action.newsFeed
        }
      }

    case fc.SET_PENDING_MESSAGE_COUNT: {
      return {
        ...state,
        pendingMessageCount: {
          newsFeedId: action.newsFeedId,
          count: action.count
        }
      }
    }

    case fc.SET_ORIGIN_MESSAGE_ID:
      return {
        ...state,
        createEditFeed: {
          ...state.createEditFeed,
          originMessageId: action.originMessageId
        }
      }

    case fc.GET_FEEDS_REQUEST:
      const { isPagination, objectId, objectType, isNewContent } = action.response
      return {
        ...state,
        newsFeedType: objectType,
        feeds: {
          ...state.feeds,
          loading: isNewContent ? false : true,
          list: isPagination || isNewContent ? [...state.feeds.list] : [],
          stats: isPagination || isNewContent ? { ...state.feeds.stats } : null,
          error: ''
        }
      }
    case fc.GET_FEEDS_SUCCESS: {
      let updatedList = [...state.feeds.list]
      if (action.updatedResponse) {
        const { content, moderation_info, auth_user, newsfeed, objectId, workplaceIds, isNewContent, members } =
          action.updatedResponse
        if (isNewContent) {
          updatedList = [...content.messages, ...state.feeds.list]
        } else if (action.updatedResponse.isPagination && content && content.messages) {
          updatedList = [...state.feeds.list, ...content.messages]
        } else if (state.feeds.list.length === 0) {
          updatedList = content && content.messages ? [...content.messages] : []
        }
        let updatedUsers = getUpdatedFeedUsers([...state.users], [...content.users])
        let mixrFeeds = state.newsFeedList.mixrs
        let groupFeeds = state.newsFeedList.groups
        let selectedNewsFeed = newsfeed || {}
        if (state.newsFeedType === 'organization') {
          selectedNewsFeed =
            content?.post_groups_data && content.post_groups_data?.length >= 1 && content.post_groups_data[0]
          mixrFeeds = content?.post_mixrs_data?.map((m) => Object.assign(m, { type: 'mixr' }))
          groupFeeds = content?.post_groups_data?.map((g) => Object.assign(g, { type: 'group' }))
        }
        return {
          ...state,
          users: updatedUsers,
          newsFeedId: selectedNewsFeed?.newsfeed_id || selectedNewsFeed?.id,
          feeds: {
            ...state.feeds,
            error: '',
            loading: false,
            success: true,
            list: updatedList,
            stats: content.stat
          },
          membersWithActivities: members,
          organizationId: state.newsFeedType === 'organization' ? objectId : 0,
          workplaceIds: state.newsFeedType === 'organization' ? workplaceIds : '',
          selectedNewsFeed:
            state.newsFeedType === 'organization'
              ? {
                  ...state.selectedNewsFeed,
                  id: selectedNewsFeed?.newsfeed_id,
                  title: newsfeed?.group_title,
                  picture: newsfeed?.group_picture,
                  typeId: newsfeed?.group_id,
                  type: 'group'
                }
              : state.selectedNewsFeed,
          newsFeedList:
            state.newsFeedType === 'organization'
              ? {
                  ...state.newsFeedList,
                  mixrs: mixrFeeds,
                  groups: groupFeeds
                }
              : state.newsFeedList,
          draftMessages: content.message_draft,
          moderation_info: moderation_info,
          authUser: auth_user
        }
      }
    }
    case fc.GET_FEEDS_FAILURE: {
      return {
        ...state,
        feeds: {
          ...state.feeds,
          loading: false,
          success: false,
          error: action.error
        }
      }
    }

    case fc.POST_MESSAGE_REQUEST: {
      const { originMessageId } = action.response
      return {
        ...state,
        createEditFeed: {
          ...state.createEditFeed,
          loading: true,
          action: 'create',
          originMessageId: originMessageId
        }
      }
    }
    case fc.POST_MESSAGE_SUCCESS: {
      if (response) {
        const { content, draftMessageFeedId } = response
        for (let feed in content.message_draft) {
          for (let key in feed) {
            if (draftMessageFeedId) {
              delete content.message_draft[feed][draftMessageFeedId]
            } else if (key == 0) {
              delete content.message_draft[feed][key]
            }
          }
        }
        const updatedDraftMessages = { ...content.message_draft }
        if (draftMessageFeedId >= 0) {
          //0 is for new message
          delete updatedDraftMessages[draftMessageFeedId]
        }

        let updatedUsers = getUpdatedFeedUsers([...state.users], [...content.users])
        return {
          ...state,
          users: updatedUsers,
          createEditFeed: {
            ...state.createEditFeed,
            loading: false,
            success: true
          },
          feeds: {
            ...state.feeds,
            list: content.messages
          },
          draftMessages: updatedDraftMessages //updated draftmessages after removing posted one
        }
      }
    }
    case fc.POST_MESSAGE_FAILURE: {
      return {
        ...state,
        createEditFeed: {
          ...state.createEditFeed,
          loading: false,
          success: false,
          error: action.error,
          originMessageId: 0
        }
      }
    }

    case fc.ADD_REACTION_REQUEST:
    case fc.DELETE_REACTION_REQUEST: {
      return {
        ...state,
        reaction: {
          ...state.reaction,
          loading: true,
          data: { code: response.reactionCode, messageId: response.messageId }
        }
      }
    }
    case fc.PIN_MESSAGE_SUCCESS:
    case fc.UNPIN_MESSAGE_SUCCESS:
    case fc.ADD_REACTION_SUCCESS:
    case fc.DELETE_REACTION_SUCCESS:
      if (response) {
        const { newsfeed, content } = response
        return {
          ...state,
          reaction: {
            ...state.reaction,
            loading: false,
            success: true,
            data: null
          },
          feeds: {
            ...state.feeds,
            list: content.messages
          }
        }
      }
    case fc.ADD_REACTION_FAILURE:
    case fc.DELETE_REACTION_FAILURE:
      return {
        ...state,
        reaction: {
          ...state.reaction,
          loading: false,
          success: false,
          data: null,
          error: action.error
        }
      }
    case fc.EDIT_MESSAGE_REQUEST: {
      return {
        ...state,
        createEditFeed: {
          ...state.createEditFeed,
          loading: true,
          action: 'update'
        }
      }
    }
    case fc.EDIT_MESSAGE_SUCCESS:
      if (response) {
        const { content } = response
        return {
          ...state,
          createEditFeed: {
            ...state.createEditFeed,
            loading: false,
            success: true
          },
          feeds: {
            ...state.feeds,
            list: content.messages
          }
        }
      }
    case fc.EDIT_MESSAGE_FAILURE: {
      return {
        ...state,
        createEditFeed: {
          ...state.createEditFeed,
          loading: false,
          success: false,
          error: action.error
        }
      }
    }
    case fc.DELETE_MESSAGE_REQUEST: {
      return {
        ...state,
        deleteFeed: {
          ...state.deleteFeed,
          loading: true,
          success: false
        }
      }
    }
    case fc.DELETE_MESSAGE_SUCCESS:
      if (response) {
        const { newsfeed, content } = response
        return {
          ...state,
          deleteFeed: {
            ...state.deleteFeed,
            loading: false,
            success: true
          },
          feeds: {
            ...state.feeds,
            list: content.messages
          }
        }
      }
    case fc.DELETE_MESSAGE_FAILURE:
      return {
        ...state,
        deleteFeed: {
          ...state.deleteFeed,
          loading: false,
          success: false
        }
      }

    case fc.DELETE_FILE_FROM_MESSAGE_REQUEST: {
      return {
        ...state,
        updateMedia: {
          ...state.updateMedia,
          loading: true,
          action: 'delete',
          error: ''
        }
      }
    }
    case fc.DELETE_FILE_FROM_MESSAGE_SUCCESS: {
      const { content } = action.updatedResponse

      return {
        ...state,
        deleteFileLoading: false,
        feeds: content.messages
      }
    }
    case fc.DELETE_FILE_FROM_MESSAGE_FAILURE: {
      return {
        deleteFileLoading: false,
        ...state
      }
    }

    case fc.SAVE_DRAFT_TO_STATE: {
      return {
        ...state,
        draftMessages: {
          ...state.draftMessages,
          [action.draftMessageFeedId]: {
            message: action.draftMessage
          }
        }
      }
    }

    case fc.TRANSLATE_MESSAGE_REQUEST:
      return {
        ...state,
        translate: {
          ...state.translate,
          loading: true,
          error: ''
        }
      }
    case fc.TRANSLATE_MESSAGE_SUCCESS: {
      const { response, messageId } = action
      const updatedFeeds = getUpdatedTranslatedFeeds(state.feeds.list, messageId, response)
      return {
        ...state,
        feeds: {
          ...state.feeds,
          list: updatedFeeds
        },
        translate: {
          ...state.translate,
          loading: false
        }
      }
    }
    case fc.TRANSLATE_MESSAGE_FAILURE:
      return {
        ...state,
        translate: {
          ...state.translate,
          loading: false,
          error: action.error
        }
      }

    case fc.GET_FEED_BLOCK_REQUEST:
      return {
        ...state,
        feeds: {
          ...state.feeds,
          loading: true
        }
      }
    case fc.GET_FEED_BLOCK_SUCCESS: {
      if (action.response) {
        const { feed_block, newsfeed, entity } = action.response
        return {
          ...state,
          feeds: {
            ...state.feeds,
            list: feed_block.messages,
            loading: false,
            error: '',
            success: true,
            loggedUserData: action.response.logged_user
          },
          users: feed_block.users,
          draftMessages: feed_block.message_draft,
          newsFeedId: newsfeed.id,
          newsFeedType: entity.type,
          entity: entity,
          groupId: entity.type === 'group' ? entity.id : entity.mixrs_group_id
        }
      }
    }
    case fc.GET_FEED_BLOCK_FAILURE:
      return {
        ...state,
        feeds: {
          ...state.feeds,
          loading: false,
          error: action.error
        }
      }

    case fc.LOCATE_POST_IN_NEWSFEED_SUCCESS: {
      return {
        ...state,
        scrollToPost: {
          ...state.scrollToPost,
          newsfeed_id: action.response.newsfeed_id,
          post_id: action.response.post_id,
          content_offset: action.response.content_offset
        }
      }
    }
    case fc.CREATE_BG_TAG_REQUEST: {
      return {
        ...state,
        feedTags: {
          ...state.feedTags,
          loading: true
        }
      }
    }
    case fc.CREATE_BG_TAG_SUCCESS: {
      const { tag, draftMessageFeedId } = action.response
      for (let feed in state.draftMessages) {
        for (let key in feed) {
          if (draftMessageFeedId >= 0 && draftMessageFeedId == key) {
            delete state.draftMessages[feed][draftMessageFeedId]
          }
        }
      }
      const updatedDraftMessages = { ...state.draftMessages }
      if (draftMessageFeedId >= 0) {
        //0 is for new message
        delete updatedDraftMessages[draftMessageFeedId]
      }

      return {
        ...state,
        feedTags: {
          ...state.feedTags,
          loading: false,
          tags: [...state.feedTags.tags, tag]
        },
        draftMessages: updatedDraftMessages
      }
    }
    case fc.CREATE_BG_TAG_FAILURE: {
      return {
        ...state,
        feedTags: {
          ...state.feedTags,
          loading: false,
          error: action.error
        }
      }
    }

    case fc.REMOVE_PROCESSED_TAG: {
      const updatedTags = state.feedTags.tags.filter((tag) => tag !== action.tag)
      return {
        ...state,
        feedTags: {
          ...state.feedTags,
          tags: updatedTags
        }
      }
    }

    case fc.GET_SHARING_TAG_FILES_REQUEST: {
      return {
        ...state,
        sharedTags: {
          ...state.sharedTags,
          loading: true
        }
      }
    }
    case fc.GET_SHARING_TAG_FILES_SUCCESS: {
      const { files } = action.response
      return {
        ...state,
        sharedTags: {
          ...state.sharedTags,
          files: files,
          loading: false
        }
      }
    }
    case fc.GET_SHARING_TAG_FILES_FAILURE: {
      return {
        ...state,
        sharedTags: {
          ...state.sharedTags,
          loading: false,
          error: action.error
        }
      }
    }
    case fc.REMOVE_SHARING_PROCESSED_TAG_FILES: {
      return {
        ...state,
        sharedTags: {
          ...state.sharedTags,
          files: []
        }
      }
    }
    default:
      return state
  }
}

function getUpdatedFeedUsers(existingUsers, newUsers) {
  let updatedUsers = [...existingUsers]
  if (newUsers && newUsers.length > 0) {
    for (let i = 0; i < newUsers.length; i++) {
      if (updatedUsers.some((u) => u.id === newUsers[i].id)) {
        continue
      } else {
        updatedUsers.push(newUsers[i])
      }
    }
  }
  return updatedUsers
}

function getUpdatedTranslatedFeeds(feeds, messageId, translateResponse) {
  const { language_source, language_target, original_text, translated_text } = translateResponse
  const updatedFeeds = feeds.map((feed) => {
    if (feed.id === messageId) {
      feed.languageTarget = language_target
      feed.languageSource = language_source
      feed.originalText = original_text
      feed.translatedText = translated_text
    } else {
      const reponses = feed.responses
      const updatedFeeds = getUpdatedTranslatedFeeds(reponses, messageId, translateResponse)
      feed.responses = updatedFeeds
    }
    return feed
  })
  return updatedFeeds
}
